import { render, staticRenderFns } from "./ShareGet.vue?vue&type=template&id=051f2144"
import script from "./ShareGet.vue?vue&type=script&lang=js"
export * from "./ShareGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports